import {t} from "../../i18n";
import {bindInputListeners, showValidationErrors} from "../../utils/formHelpers";

export default function authRegister({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render() {
        const $el = $(`
    <div class="booking-register-row active" data-auth-step="booking-register">
        <button class='login-close-button'>&times;</button>
        <h3>${t('create_an_account')}</h3>
        <p>${t('almost_done')}</p>
        <form class="booking-register-form">
            <div class="form-row">
                <label for="bookingRegisterName">${t('full_name')}</label>
                <input required type='text' id="bookingRegisterName" name="name"/>
            </div>
            <div class="form-row">
                <label for="bookingRegisterPhone">${t('phone')}</label>
                <input type='number' id="bookingRegisterPhone" name="phone"/>
                <p class="field-error field-phone-error" style="display:none;">
                    {{ trans('account.form.please_enter_a_valid_number') }}
                </p>
                <p class="field-error field-phone-length-error" style="display:none;">
                    {{ trans_choice('account.form.phone_number_must_have_at_least_n_digits', 10) }}
                </p>
            </div>
            <div class="form-row">
                <label for="bookingRegisterEmail">${t('email')}</label>
                <input required type='email' id="bookingRegisterEmail" name="email"/>
            </div>
            <div class="form-row">
                <label for="bookingRegisterConfirmEmail">${t('confirm_email_address')}</label>
                <input required type='email' id="bookingRegisterConfirmEmail" name="email_confirmation"/>
                <p class="field-error field-email-error" style="display:none;">${t('emails_do_not_match')}</p>
            </div>
            <div class="form-row">
                <label for="bookingRegisterPassword">${t('password')}</label>
                <input required type='password' id="bookingRegisterPassword" name="password"/>
                <p class="field-error field-password-length-error" style="display:none;">${t('password_must_have_at_least_6_characters')}</p>
            </div>
            <div class="form-row form-policies">
                <div>
                    <input required="" type="checkbox" id="bookingRegisterPolicies">
                    <label for="bookingRegisterPolicies">
                        ${t('agree_with_the')}
                        <a href="https://www.ontimeagenda.com/politica-de-confidentialitate" target="_blank">${t('privacy_policy')}</a>,
                        <a href="https://www.ontimeagenda.com/gdpr" target="_blank">${t('terms_of_use')}</a>
                        ${t('and')}
                        <a href="https://www.ontimeagenda.com/termeni-si-conditii" target="_blank">${t('terms_of_services')}</a>
                    </label>
                </div>
                <div>
                    <input type="checkbox" id="bookingRegisterNews">
                    <label for="bookingRegisterNews">
                        ${t('i_wani_ti_receivi_marketini_stuff')}
                    </label>
                </div>
                <div class="error-messages"></div>
                <div class="form-actions">
                    <button type="submit">${t('continue')}</button>
                </div>
            </div>
        </form>
    </div>
    `);

        $el.find("#bookingRegisterEmail").val(sharedState.email);

        $el.on('submit', '.booking-register-form', e => {
            e.preventDefault();

            let name =          $el.find("#bookingRegisterName").val();
            let phone =         $el.find("#bookingRegisterPhone").val();
            let email =         $el.find("#bookingRegisterEmail").val();
            let confirmEmail =  $el.find("#bookingRegisterConfirmEmail").val();
            let password =      $el.find("#bookingRegisterPassword").val();
            let wantsNews =     $el.find("#bookingRegisterNews").prop("checked");

            if(email === confirmEmail && password.length >= 6) {
                // save phone and email for next steps
                sharedState.phone = phone;
                sharedState.email = email;

                api.post(routes.webRegister, {
                    data: {
                        name: name,
                        email: email,
                        password: password,
                        phone: phone,
                        wantsNews: wantsNews
                    },
                    success: (data) => {

                        onNext('booking-sms')
                    },
                    error: (err) => {
                        console.warn('Failed:', err);
                        showValidationErrors($el, err.data.errors || {});
                    }
                })
            } else {
                const errors = {}
                // $el.find(".error-messages").empty();
                if (email !== confirmEmail) {
                    // $el.find(".error-messages").append(`<p class="error">${t('emails_do_not_match')}</p>`);
                    errors.email_confirmation = t('emails_do_not_match');
                }
                if (password.length < 6) {
                    // $el.find(".error-messages").append(`<p class="error">${t('password_must_have_at_least_6_characters')}</p>`);
                    errors.password = t('password_must_have_at_least_6_characters');
                }
                showValidationErrors($el, errors || {});
            }
        })

        bindInputListeners($el);

        return $el;
    }

    return { render };
}